import React from 'react';
import { Box, Grid, Avatar } from '@mui/material';

const SelectAvatar = ({ avatars, selectedAvatar, setSelectedAvatar }) => (
  <Box sx={{
    maxHeight: '35vh',
    overflowY: 'auto',
    px: 2,
    '&::-webkit-scrollbar': { width: 0 }, // Hides the scrollbar in WebKit browsers (Chrome, Safari)
    scrollbarWidth: 'none', // Hides the scrollbar in Firefox
    msOverflowStyle: 'none', // Hides the scrollbar in Edge
  }}>
    <Grid container spacing={2} justifyContent="center">
      {avatars.map((avatar, index) => (
        <Grid item xs={3} key={index} sx={{ display: 'flex', justifyContent: 'center' }}>
          <Avatar
            src={avatar}
            alt={`Avatar ${index + 1}`}
            sx={{
              width: 64,
              height: 64,
              cursor: 'pointer',
              border: selectedAvatar === avatar ? '3px solid' : 'none',
              transition: 'transform 0.2s ease-in-out',
              '&:hover': { transform: 'scale(1.1)' }
            }}
            onClick={() => setSelectedAvatar(avatar)}
          />
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default SelectAvatar;
